{lazyLoadJs} = require './helpers'

FIXED_PURCHASE_QTY = 1

getTotal = (amount, type) ->
  amount = amount.replace(/\$|\s/g, '')
  total =
    label: I18n.t 'js.modules.applepay.total'
    amount: amount
  if type
    total.type = type
  total

confirmationRedirect = (url) -> window.location = "#{url}&msg=complete_failed"

receiptRedirect = (url) -> window.location = url

hasErrors = (res) ->
  res.flashErrors?.length > 0 or res.apiErrors?.length > 0 or res.error

showPaymentSheet = (opts) ->

  { totalAmount
    currencyCode
    csrf
    confirmationUrl
    ioBlackBox
  } = opts

  countryCode = I18n.country

  matches = /\/deals\/(.+)\/confirmation\?pledge_id=([0-9]+)/.exec confirmationUrl

  dealId = matches[1]

  optionId = matches[2]

  if not dealId or not optionId
    window.location = confirmationUrl
    return

  paymentRequest = {
    currencyCode
    countryCode
    total: getTotal totalAmount
    supportedNetworks: ['amex', 'discover', 'masterCard', 'visa' ]
    merchantCapabilities: [ 'supports3DS' ]
    requiredBillingContactFields: ['postalAddress', 'email']
  }

  session = new ApplePaySession(1, paymentRequest)

  session.onpaymentauthorized = (event) ->
    {billingContact, token} = event.payment

    payload =
      ioBlackBox: ioBlackBox
      items: [{
        deal_id: dealId
        option_id: optionId
        quantity: FIXED_PURCHASE_QTY
      }]
      encrypted_payment_data: JSON.stringify token.paymentData
      type: 'applepay'
      billing_record:
        payment_id: 'applepay'
        type: 'applepay'
        street_address_1: billingContact.addressLines.join(', ')
        country: billingContact.country
        city: billingContact.locality
        state: billingContact.administrativeArea
        postal_code: billingContact.postalCode

    $.ajax
      type: 'POST'
      contentType: 'application/x-www-form-urlencoded'
      dataType: 'json'
      url: '/deals/new/orders'
      headers:
        "x-csrf-token": csrf
      data: payload
      success: (data) ->
        if hasErrors data
          session.completePayment ApplePaySession.STATUS_FAILURE
          confirmationRedirect confirmationUrl
        else
          session.completePayment ApplePaySession.STATUS_SUCCESS
          receiptRedirect data.url

      error: ->
        session.completePayment ApplePaySession.STATUS_FAILURE
        confirmationRedirect confirmationUrl

  session.onpaymentmethodselected = (e) ->
    session.completePaymentMethodSelection getTotal(totalAmount, 'final'), []

  session.onvalidatemerchant = ({validationURL}) ->
    $.ajax
      type: 'POST'
      dataType: 'json'
      data:
        url: validationURL
      headers:
        "x-csrf-token": csrf
      url: '/checkout/payment/validation'
      success: (merchantSession) ->
        session.completeMerchantValidation merchantSession

  session.begin()

shouldBucketTheUserIntoExp = (expName, cb) ->
  Finch.experiment expName,
    Control: ->
      cb false
    Treatment: ->
      cb true

getIovationBlackBox = (iovationUrl, cb)->
  window.io_bbout_element_id = 'ioBlackBox'
  window.io_install_flash = false
  window.io_enable_rip = true
  window.io_install_stm = false
  window.io_exclude_stm = 12
  $('body').append("<input type='hidden' name='#{io_bbout_element_id}' id='#{io_bbout_element_id}'>")
  lazyLoadJs iovationUrl, ->
    cb($("##{io_bbout_element_id}").val())

module.exports =

  hasValidConfirmationLink: (href) ->
    href.match /\/deals\/.+\/confirmation\?pledge_id=[0-9]+/i

  start: (opts, getTotalAmount, getApplePayButton, renderApplePayFeature, updatePromoCodeHandler, getConfirmationUrl, expName) ->
    return unless window.ApplePaySession and opts.isApplePayEnabled
    ApplePaySession.canMakePaymentsWithActiveCard opts.appleMerchantId
      .then (canMakePayments) ->
        OptimizeSuite.TrackingHub.add('[applepay-deal-page]', {canMakePayments})
        return unless canMakePayments
        $.get '/deals/proxy/user/valid', ({isApplePayEligible})->
          return unless isApplePayEligible
          shouldBucketTheUserIntoExp expName, (res) ->
            return unless res
            getIovationBlackBox opts.iovationUrl, (ioBlackBox)->
              updatePromoCodeHandler()
              renderApplePayFeature()
              getApplePayButton()
                .click (e) ->
                  totalAmount = getTotalAmount()
                  showPaymentSheet(_.extend {}, opts, {
                    totalAmount,
                    ioBlackBox,
                    confirmationUrl: getConfirmationUrl()
                    })
                  return false
